module.exports = __webpack_public_path__ + "img/app-text.ba6dc90e.png";